var map = {
	"./about.js": "892e",
	"./academic-year.js": "a1af",
	"./appreciation.js": "d0f9",
	"./approval-work-flow.js": "8373",
	"./attendance-device.js": "851d",
	"./attendance-setting.js": "cd66",
	"./attendance-shift.js": "6052",
	"./auth.js": "831c",
	"./bank-profile.js": "b53f",
	"./branch.js": "3670",
	"./building.js": "fbc8",
	"./calendar.js": "2a4b",
	"./campus-attendance.js": "52d3",
	"./car-attendance.js": "af73",
	"./card-to-be-print.js": "dc36",
	"./category.js": "f6f1",
	"./certificate-operation-print.js": "7418",
	"./class-attendance.js": "ad4b",
	"./class-operation.js": "ba50",
	"./class-teaching.js": "f1a2",
	"./company.js": "542f",
	"./corporate-partner.js": "e7c1",
	"./credit-transfer.js": "31ff",
	"./dashboard.js": "d748",
	"./default-credit-day.js": "7d4b",
	"./department.js": "ab81",
	"./disciplinary-activity.js": "4ddc",
	"./disciplinary-condition.js": "d8fa",
	"./disciplinary-letter.js": "18e8",
	"./disciplinary-record.js": "d436",
	"./disciplinary-sub-type.js": "a98f",
	"./division.js": "13c3",
	"./employee-card-activator.js": "2906",
	"./employee-daily-timescan.js": "d299",
	"./employee.js": "5eae",
	"./error.js": "fe0e",
	"./eschool/e-exam/question.js": "7f29",
	"./eschool/homework/homework.js": "f7b3",
	"./event.js": "361d",
	"./exam-schedule.js": "a823",
	"./exchange-rate.js": "ca31",
	"./fee-group.js": "b0c52",
	"./fee-setup.js": "ff7f",
	"./fee-type.js": "133d",
	"./file-manager.js": "a08c",
	"./front-cover.js": "c55d",
	"./generate-total-score.js": "9ea4",
	"./grade.js": "e21d",
	"./grading-definition.js": "b1c6",
	"./group-chat-responsible.js": "2083",
	"./health-category.js": "c9bd",
	"./health-item.js": "f110",
	"./history-tracking.js": "b6ad",
	"./holiday-rule.js": "e921",
	"./holiday.js": "d38e",
	"./home.js": "3165",
	"./hospital-profile.js": "fa46",
	"./info-inquiry.js": "16a9",
	"./inventory-list.js": "b0f2",
	"./invoice-confirm.js": "6d7a",
	"./khmer-secondary-schedule.js": "ba92",
	"./leave-record.js": "77ae",
	"./level.js": "a6bb",
	"./location-settlement.js": "ac40",
	"./main-program.js": "2690",
	"./new-student-unpaid.js": "f0ab",
	"./news.js": "f66a",
	"./notification-history.js": "1807",
	"./notification-manual.js": "e549",
	"./notification-monitoring.js": "1487",
	"./notification-schedule.js": "2843",
	"./notification-template.js": "13ed",
	"./parent-communication-chat.js": "b822",
	"./parent-profile.js": "1653",
	"./payment-adjustment.js": "6ccb",
	"./payment-announcement.js": "56a4",
	"./payment-testing.js": "9c89",
	"./pickup-card-activator.js": "5d85",
	"./pickup-card-creation.js": "b5aa",
	"./pickup-display.js": "b587",
	"./pickup-history.js": "b099",
	"./portfolio-photo.js": "5031",
	"./position.js": "65cb",
	"./product-location.js": "df18",
	"./product-movement.js": "17d7",
	"./product.js": "ff52",
	"./promotion.js": "7428",
	"./purchase-order.js": "fce3",
	"./qr-code-display-certificate.js": "a81f",
	"./report-academic.js": "ea60",
	"./report-inventory.js": "2f91",
	"./report-payment.js": "b251",
	"./reset-device-password.js": "4c11",
	"./retail-sale.js": "1d47",
	"./role.js": "c6ff",
	"./room.js": "bdab",
	"./schedule-time.js": "d0d9",
	"./schedule.js": "75aa",
	"./scholarship.js": "285f",
	"./school-contact.js": "f90b",
	"./score-assessment.js": "42a5",
	"./score-component.js": "d890",
	"./service-subscription.js": "b3d0",
	"./setup-landing-page.js": "51fc",
	"./signature.js": "4d6f",
	"./stock-adjustment.js": "b07c",
	"./stock-count-entry.js": "9724",
	"./stock-in.js": "9a45",
	"./stock-transfer.js": "84d1",
	"./student-card-activator.js": "e9cd",
	"./student-enrollment.js": "c769",
	"./student-follow-up.js": "89d6",
	"./student-gallery-bk.js": "cb40",
	"./student-gallery.js": "4c14",
	"./student-health.js": "c556",
	"./student-invoice.js": "a87a",
	"./student-profile.js": "e6cc",
	"./student-scoring-component-entry.js": "e55e",
	"./student-scoring-entry.js": "d927",
	"./student-transfer.js": "2035",
	"./student-vehicle.js": "6af3",
	"./studnet-top-five.js": "8cf2",
	"./study-time.js": "4748",
	"./sub-program.js": "e616",
	"./subject-activity.js": "9c10",
	"./subject-cores.js": "2c82",
	"./subject-electives.js": "6bec",
	"./subject-grading-range.js": "0a15",
	"./supplier.js": "5b30",
	"./teacher-profile.js": "2dc4",
	"./teacher-subject-code.js": "3cc2",
	"./term-semester.js": "c302",
	"./thesis-topic.js": "f725",
	"./thesis.js": "9cb9",
	"./total-score-grading-range.js": "a001",
	"./transportation-distance.js": "3c3b",
	"./transportation-way.js": "7c18",
	"./uom-category.js": "f889",
	"./user.js": "33f5e",
	"./vehicle-operation.js": "8418",
	"./vehicle-profile.js": "7b52",
	"./vehicle-zone-profile.js": "fe7e",
	"./warehouse.js": "fd83",
	"./weekday-type.js": "108c",
	"./work-schedule.js": "b02a",
	"./year-book.js": "648f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61d6";